/**
 * Split a comma-separated value into trimmed, non-empty entries. Arrays are trimmed and filtered
 * the same way.
 */
export function parseCsv(value: string | readonly string[] | null | undefined): string[] {
  if (Array.isArray(value)) {
    return value.map((entry) => entry.trim()).filter(Boolean);
  }

  return String(value || '')
    .split(',')
    .map((entry) => entry.trim())
    .filter(Boolean);
}
